import { NOTIFICATION_PATH } from '../url';
import ErrorSwitchCase from './ErrorHandlerService';
import HttpService from './HttpService';

const _axios = HttpService.getAxiosClient();

/**
 * Fetches unread notifications for a user.
 * Supports optional pagination (data-layer uses Pageable.unpaged() when pageSize is omitted).
 */
export const getAllNotifications = async (
  userId,
  { pageNumber = 0, pageSize } = {},
) => {
  try {
    const params = { pageNumber };
    if (pageSize != null) {
      params.pageSize = pageSize;
    }
    const response = await _axios.get(`${NOTIFICATION_PATH}/users/${userId}`, {
      params,
    });
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const clearNotification = async (notificationId) => {
  try {
    const response = await _axios.put(
      `${NOTIFICATION_PATH}?id=${notificationId}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const clearAllNotification = async (userId) => {
  try {
    const response = await _axios.put(
      `${NOTIFICATION_PATH}/users/${userId}/clearAll`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};
